import BlackSock from '../../assets/images/laundry_game/black_sock.png';
import BlueSock from '../../assets/images/laundry_game/blue_sock.png';
import BrownSock from '../../assets/images/laundry_game/brown_sock.png';
import GreenSock from '../../assets/images/laundry_game/green_sock.png';
import PurpleSock from '../../assets/images/laundry_game/purple_sock.png';
import RedSock from '../../assets/images/laundry_game/red_sock.png';
import WhiteSock from '../../assets/images/laundry_game/white_sock.png';

export enum SockColor {
    BLACK,
    BLUE,
    BROWN,
    GREEN,
    PURPLE,
    RED,
    WHITE,
}

export const SOCK_IMAGES: Record<SockColor, string> = {
    [SockColor.BLACK]: BlackSock,
    [SockColor.BLUE]: BlueSock,
    [SockColor.BROWN]: BrownSock,
    [SockColor.GREEN]: GreenSock,
    [SockColor.PURPLE]: PurpleSock,
    [SockColor.RED]: RedSock,
    [SockColor.WHITE]: WhiteSock,
};

export const SOCK_COLORS = Object.keys(SockColor)
    .filter((k) => !Number.isNaN(Number(k)))
    .map((k) => Number(k));

export function sockFrequency(caughtSocks: SockColor[]) {
    return caughtSocks.reduce((freq, color) => {
        freq.set(color, Math.min(2, (freq.get(color) ?? 0) + 1));
        return freq;
    }, new Map<SockColor, number>());
}

export function missingColors(caughtSocks: SockColor[]): SockColor[] {
    const freq = sockFrequency(caughtSocks);
    return Array.from(SOCK_COLORS).filter((k) => freq.get(k) !== 2);
}
